import React from 'react';
import BrandLogo from './BrandLogo';

/**
 * Vertical step-list sidebar for the Personal Data Sheet form.
 *
 * `stepVisible` is a parallel boolean array — the spouse steps are hidden
 * when the client has told us they have no spouse or partner. Displayed
 * numbers come from a running counter rather than the array index so the
 * numbering stays contiguous no matter which steps are hidden.
 */
export default function ProgressSidebar({
  currentStep,
  steps,
  onStepClick,
  stepStatuses = [],
  stepVisible = [],
}) {
  let displayNo = 0;

  return (
    <nav className="cashflow-sidebar d-none d-lg-flex flex-column p-3">
      <div className="mb-3 text-center"><BrandLogo size={48} /></div>
      <p className="text-uppercase fw-semibold small text-center mb-3 px-1" style={{ color: '#fff' }}>
        Personal Data Sheet
      </p>

      <ol className="list-unstyled flex-fill cashflow-step-list">
        {steps.map((step, idx) => {
          if (stepVisible[idx] === false) return null;

          // The welcome step shows its icon instead of a number.
          if (idx > 0) displayNo += 1;

          const isActive = idx === currentStep;
          const status = stepStatuses[idx] || 'empty';

          let stateClass = 'cashflow-step--empty';
          if (isActive) {
            stateClass = 'cashflow-step--active';
          } else if (status === 'complete') {
            stateClass = 'cashflow-step--done';
          } else if (status === 'partial') {
            stateClass = 'cashflow-step--partial';
          }

          return (
            <li
              key={step.key}
              className={`cashflow-step-item ${stateClass}`}
              onClick={() => onStepClick && onStepClick(idx)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if ((e.key === 'Enter' || e.key === ' ') && onStepClick) {
                  e.preventDefault();
                  onStepClick(idx);
                }
              }}
            >
              <span className="cashflow-step-indicator">
                {!isActive && status === 'complete' ? (
                  <i className="bi bi-check-lg" />
                ) : !isActive && status === 'partial' ? (
                  <i className="bi bi-pencil-fill" style={{ fontSize: '0.6rem' }} />
                ) : idx === 0 ? (
                  <i className={`bi ${step.icon}`} style={{ fontSize: '0.75rem' }} />
                ) : (
                  <span className="cashflow-step-number">{displayNo}</span>
                )}
              </span>
              <span className="cashflow-step-label">{step.label}</span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
